import { BorrowerCard } from '@roc/ui';

export {
  BorrowerCard, BorrowerCardProps
} from '@roc/ui';

export default BorrowerCard;
